/**
 * Dog Name Generator Constants & Options
 *
 * Options for the name generator quiz.
 * Keep in sync with legacy paction/src/components/ExpertHub/components/NameGenerator/components/NameGeneratorInputs/NameGeneratorInputs.js
 */

export const colorOptions = [
  { value: 'Black', label: 'Black' },
  { value: 'Brown', label: 'Brown' },
  { value: 'White', label: 'White' },
  { value: 'Golden', label: 'Golden' },
  { value: 'Burgundy', label: 'Burgundy' },
  { value: 'Multiple Colours', label: 'Multiple Colours' },
  { value: 'Gray', label: 'Gray' },
  { value: 'Spotted', label: 'Spotted' },
  { value: 'Brindle', label: 'Brindle' }
];

export const personalityOptions = [
  { value: 'Playful', label: 'Playful' },
  { value: 'Calm', label: 'Calm' },
  { value: 'Curious', label: 'Curious' },
  { value: 'Protective', label: 'Protective' },
  { value: 'Unique', label: 'Unique' },
  { value: 'Hyperactive', label: 'Hyperactive' },
  { value: 'Loyal', label: 'Loyal' },
  { value: 'Affectionate', label: 'Affectionate' },
  { value: 'Independent', label: 'Independent' }
];

export const ambitionOptions = [
  { value: 'Fly a plane', label: 'Fly a plane' },
  { value: 'Learn a new language', label: 'Learn a new language' },
  { value: 'Write a best-selling novel', label: 'Write a best-selling novel' },
  { value: 'Climb Mount Everest', label: 'Climb Mount Everest' },
  { value: 'Start a new business', label: 'Start a new business' },
  { value: 'Be an actor or actress', label: 'Be an actor or actress' },
  { value: 'Travel the world', label: 'Travel the world' },
  { value: 'Become an artist', label: 'Become an artist' }
];

export const beliefOptions = [
  {
    value: 'Vegetarianism, pescatarian, or vegan living',
    label: 'Vegetarianism, pescatarian, or vegan living'
  },
  {
    value: 'Alternative medicine and healing',
    label: 'Alternative medicine and healing'
  },
  {
    value: 'Aliens and extraterrestrial life',
    label: 'Aliens and extraterrestrial life'
  },
  {
    value: 'Minimalism and living with less',
    label: 'Minimalism and living with less'
  },
  {
    value:
      'Psychic abilities such as extrasensory perception, clairvoyance, or precognition',
    label:
      'Psychic abilities such as extrasensory perception, clairvoyance, or precognition'
  },
  {
    value: 'The practice of mindfulness and meditation',
    label: 'The practice of mindfulness and meditation'
  }
];

export const seasonOptions = [
  { value: 'Summer', label: 'Summer' },
  { value: 'Fall', label: 'Fall' },
  { value: 'Winter', label: 'Winter' },
  { value: 'Spring', label: 'Spring' }
];

export const historicalFigureOptions = [
  {
    value: 'Albert Einstein to discuss science and innovation',
    label: 'Albert Einstein to discuss science and innovation'
  },
  {
    value: 'Cleopatra to learn about ancient history and politics',
    label: 'Cleopatra to learn about ancient history and politics'
  },
  {
    value:
      'Princess Diana to discuss philanthropy and the royal family dynamics',
    label:
      'Princess Diana to discuss philanthropy and the royal family dynamics'
  },
  {
    value: 'Leonardo da Vinci to explore art and invention',
    label: 'Leonardo da Vinci to explore art and invention'
  },
  {
    value: 'Mahatma Gandhi to discuss peace and philosophy',
    label: 'Mahatma Gandhi to discuss peace and philosophy'
  },
  {
    value: 'Nelson Mandela to discuss his dedication to activism',
    label: 'Nelson Mandela to discuss his dedication to activism'
  },
  {
    value: 'Frida Kahlo to discuss feminism expressed through art',
    label: 'Frida Kahlo to discuss feminism expressed through art'
  },
  {
    value: 'Confucius to discuss Eastern philosophy',
    label: 'Confucius to discuss Eastern philosophy'
  }
];

export const favouriteColorOptions = [
  { value: 'Red', label: 'Red' },
  { value: 'Yellow', label: 'Yellow' },
  { value: 'Orange', label: 'Orange' },
  { value: 'Green', label: 'Green' },
  { value: 'Blue', label: 'Blue' },
  { value: 'Purple', label: 'Purple' },
  { value: 'Pink', label: 'Pink' }
];

export const animalOptions = [
  { value: 'Toucan', label: 'Toucan' },
  { value: 'Komodo dragon', label: 'Komodo dragon' },
  { value: 'Kangaroo', label: 'Kangaroo' },
  { value: 'Giraffe', label: 'Giraffe' },
  { value: 'Flamingo', label: 'Flamingo' },
  { value: 'Chameleon', label: 'Chameleon' },
  { value: 'Siberian tiger', label: 'Siberian tiger' },
  { value: 'Ocelot', label: 'Ocelot' },
  { value: 'Macaque snow monkey', label: 'Macaque snow monkey' }
];

export const kindOptions = [
  { value: 'Trendy', label: 'Trendy' },
  { value: 'Classic', label: 'Classic' },
  { value: 'Provocative', label: 'Provocative' },
  { value: 'Unique', label: 'Unique' },
  { value: 'Meaningful', label: 'Meaningful' }
];

export const cultureOptions = [
  { value: 'North American', label: 'North American' },
  { value: 'Celtic', label: 'Celtic' },
  { value: 'Middle Eastern', label: 'Middle Eastern' },
  { value: 'Southeast Asian', label: 'Southeast Asian' },
  { value: 'Greek', label: 'Greek' },
  { value: 'Indigenous', label: 'Indigenous' },
  { value: 'Chinese', label: 'Chinese' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Korean', label: 'Korean' },
  { value: 'French', label: 'French' },
  { value: 'African', label: 'African' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Scandinavian', label: 'Scandinavian' },
  { value: 'Slavic', label: 'Slavic' }
];

export const sexOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' }
];

export const defaultAnswers = {
  size: '',
  color: '',
  sex: 'female',
  personality: [] as string[],
  ambition: [] as string[],
  belief: '',
  season: '',
  historicalFigure: '',
  favouriteColor: [] as string[],
  animal: [] as string[],
  kind: [] as string[],
  culture: ''
};

export type NameGeneratorAnswers = typeof defaultAnswers;
